import {
  AdvancedImage,
  lazyload,
  placeholder,
  responsive,
} from '@cloudinary/react';
import { CloudinaryImage } from '@cloudinary/url-gen';
import { Box, Typography } from '@mui/material';
import React from 'react';

export default function LandingCard({ title, description, children }) {
  const logo = new CloudinaryImage('tanyaegyetem/TE_logo_transparent', {
    cloudName: 'scriptantia',
  });
  const logoF = new CloudinaryImage('tanyaegyetem/FenttartFejl_logo', {
    cloudName: 'scriptantia',
  });
  return (
    <Box
      sx={{
        width: '90%',
        margin: '5% auto',
        padding: { xs: '10px', sm: '30px', md: '40px' },
        flexGrow: 0,
        width: {
          xs: '100%', // Extra kis képernyőkön (mobil)
          sm: '90%', // Kis képernyőkön
        },
        height: {
          xs: '100%',
        },
        borderRadius: {
          xs: 0,
        },
        boxShadow: {
          xs: 'none',
        },
        margin: {
          xs: 0,
        },
        border: {
          xs: 0,
        },
        flexGrow: {
          xs: 1,
        },
      }}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        flexWrap='nowrap' // Megakadályozza, hogy a képek egymás alá kerüljenek
        sx={{
          overflow: 'hidden', // Megakadályozza a kilógást
          whiteSpace: 'nowrap',
          width: '100%',
        }}
      >
        <Box flexShrink={1} maxWidth='30%'>
          <AdvancedImage
            cldImg={logo}
            style={{ width: '100%' }} // Automatikus méretezés
            plugins={[
              lazyload(),
              responsive({ steps: [200, 400, 600] }),
              placeholder(),
            ]}
          />
        </Box>
        <Box flexGrow={1} textAlign='center' maxWidth='60%'>
          <Typography
            variant='h1'
            sx={{
              fontSize: {
                xs: '1.3rem',
                sm: '1.8rem',
                md: '3rem',
                lg: '3rem',
                xl: '3.5rem',
              },
            }}
          >
            {title}
          </Typography>
          <Typography
            variant='h4'
            sx={{
              maxWidth: {
                xs: '70%',
                sm: '100%',
                md: '100%',
                lg: '100%',
                xl: '100%',
              },
              fontSize: {
                xs: '0.7rem',
                sm: '0.9rem',
                md: '1.3rem',
                lg: '1.7rem',
                xl: '2rem',
              },
              textWrap: 'wrap',
            }}
          >
            {description}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 1,
            alignItems: 'center',
            gap: 1,
            maxWidth: '20%',
          }}
        >
          <AdvancedImage
            cldImg={logoF}
            style={{ width: '60%', height: 'auto' }} // Automatikus méretezés
            plugins={[
              lazyload(),
              responsive({ steps: [70, 100, 150] }),
              placeholder(),
            ]}
          />
          <Typography
            variant='h6'
            sx={{
              fontSize: {
                xs: '0.4rem',
                sm: '0.5rem',
                md: '0.6rem',
                lg: '0.8rem',
                xl: '1rem',
              },
              textWrap: 'wrap',
            }}
          >
            A Fenntartható Visszafejlődés tudástára
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  );
}
